import { render } from "./DeployVM.vue?vue&type=template&id=5d0fb8d2&scoped=true"
import script from "./DeployVM.vue?vue&type=script&lang=js"
export * from "./DeployVM.vue?vue&type=script&lang=js"

import "./DeployVM.vue?vue&type=style&index=0&id=5d0fb8d2&lang=less&scoped=true"
import "./DeployVM.vue?vue&type=style&index=1&id=5d0fb8d2&lang=less"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0fb8d2"]])

export default __exports__